import { DebugType } from '@/enum/DebugType'

export class DebugItem {
    public date:Date
    public debugType:DebugType
    public misId:number|null
    public misLibelle:string|null    
    public cycle:number|null
    public data:any        
    

    constructor({date = '', debugType=DebugType.UNDEFINED, misId=null,misLibelle='',wobTrmId=null, cycle=null, data = null} = {}) {
        this.date = new Date(date)
        this.debugType = debugType
        this.cycle = cycle
        this.misId = misId
        this.misLibelle = misLibelle
        this.data = data
    }


    static createFromWob(wob:any) {
        return new DebugItem({
            date : wob.wobDat,
            debugType : DebugType.WOB,
            misId : wob.targetMisId || wob.misId,
            misLibelle : '',
            cycle : wob.gliCycle,
            data : wob
        })
    }
} 